import cn from 'clsx';
import { FC } from 'react';

import { ColorPalette, IconType } from '../../../../types';
import { colorToTailwindTheme } from '../../../../utils';
import Icon from '../../../Icon';

import s from './DefaultTitle.module.scss';

export interface DefaultTitleProps {
  title: string;
  titleColor?: ColorPalette;
  titleIcon?: IconType;
  amount: string;
  amountColor?: ColorPalette;
}

const DefaultTitle: FC<React.PropsWithChildren<React.PropsWithChildren<DefaultTitleProps>>> = ({ title, titleColor, titleIcon, amount, amountColor }) => {
  const tailwindTitleColor = colorToTailwindTheme(titleColor || 'gray.600', 'text');
  const tailwindAmountColor = colorToTailwindTheme(amountColor || 'gray.800', 'text');

  return (
    <div className={s.wrap}>
      <p className={s.title}>
        <span className={cn(s.title_text, tailwindTitleColor)}>{title}</span>
        {titleIcon && <Icon type={titleIcon} size={16} color="gray.600" className={s.icon} />}
      </p>
      <p className={cn(s.amount, tailwindAmountColor)}>{amount}</p>
    </div>
  );
};

export default DefaultTitle;
